const TransactionalCreditDefaults={
    CREATE_PAYMENT:'CreatePayment',
    PAYMENT_INQUIRY:'InquiryPayment',
    SHAHKAR:'Shahkar',
    OTP_REQUEST:'RequestOTP',
    OTP_VERIFY:'VerifyOTP',
    INIT_CONFIRM:'InitConfirm',
    TRANSACTIONAL_CREDIT_INQUIRY:"TransactionalCreditInquiry",
    FINAL:"Final",

}
export {TransactionalCreditDefaults}